module.exports = __webpack_public_path__ + "img/tutorial_mindWeather_01.27055cf7.png";